import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysAsteriskStarMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  return (
    <SystemMessage>
      {raw.sysAsteriskContent?.color === 'NO_STAR'
        ? t('scene.chatWorkspace.messageThread.systemMessage.starRemoved', {
            who: raw.sysAsteriskContent?.assistantName,
          })
        : t('scene.chatWorkspace.messageThread.systemMessage.starAdded', {
            who: raw.sysAsteriskContent?.assistantName,
            color: t(`filter.${raw.sysAsteriskContent?.color!}`),
          })}
    </SystemMessage>
  );
});
